// sections/DetailFinancialSummarySection.tsx

import { usePayableDetail } from "../../hooks/usePayableDetail";

const DetailFinancialSummarySection = () => {
  const { detail } = usePayableDetail();

  if (!detail) return null;

  return (
    <section
      className="
        rounded-xl
        border border-stroke
        bg-white
        p-6
        shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      <h4 className="mb-5 text-base font-semibold text-black dark:text-white">
        Resumen Financiero
      </h4>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {/* Total Facturado */}
        <div
          className="
            rounded-lg
            border border-gray
            bg-gray-2
            p-4
            dark:border-strokedark
            dark:bg-boxdark-2
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Total Facturado
          </p>

          <p className="text-title-xsm font-semibold text-black dark:text-white">
            ${Number(detail.totalAmount).toFixed(2)}
          </p>
        </div>

        {/* Total Cobrado */}
        <div
          className="
            rounded-lg
            border border-meta-3/20
            bg-meta-3/5
            p-4
            dark:border-meta-3/30
            dark:bg-meta-3/10
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Total Cobrado
          </p>

          <p className="text-title-xsm font-semibold text-meta-3">
            ${Number(detail.paidAmount).toFixed(2)}
          </p>
        </div>

        {/* Pendiente */}
        <div
          className="
            rounded-lg
            border border-primary/20
            bg-primary/5
            p-4
            dark:border-primary/30
            dark:bg-primary/10
          "
        >
          <p className="mb-1 text-sm font-medium text-body dark:text-bodydark">
            Pendiente
          </p>

          <p className="text-title-sm font-bold text-primary">
            ${Number(detail.pendingAmount).toFixed(2)}
          </p>
        </div>
      </div>
    </section>
  );
};

export default DetailFinancialSummarySection;